import OptionsPanel from "./OptionsPanel.js"

export default class FontFamily extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Font Family" // TODO: This needs to be localized
    this.setting = "fontFamily"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
